import React, { Component } from 'react';
import '../css/Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer>
        <p>
          © 2021 Copyright - Todos os direitos reservados
          <br />
          Grupo 16 - Turma 14 Tribo A - Trybe
          Amanda Zotelli, Dandara Dias, Flávio Pires, Maurício Leite e Riquelme Bandeira
        </p>
      </footer>
    );
  }
}

export default Footer;
